const themeTablePush = () => import('@/views/main/dataList/themeTablePush.vue')
export default {
  path: '/main/dataList/themeTablePush/:id',
  name: 'themeTablePush',
  component: themeTablePush,
  children: []
}
